import { PaymentRequestLinks } from '@frontend/api-weave-pay';
import { PaymentsPlatform } from '@frontend/payments-platform';

export interface LocationPortalData {
  email?: string;
  id?: string;
  isPortalEnabled?: boolean;
  newPortalEnabled?: boolean;
  isLive?: boolean;
  logo?: string;
  name?: string;
  phoneNumber?: string;
  processor?: PaymentsPlatform.ActiveGateway;
}

export interface PortalDataType {
  amount?: number;
  attachment?: string | null;
  links?: PaymentRequestLinks;
  locationData?: LocationPortalData;
  onBehalfOf?: string;
  requestId?: string;
  setupIntentId?: string;
  person?: {
    name?: string;
    id?: string;
    hasBirthdate?: boolean;
  };
  settings: {
    allowSaveACHOnFile?: boolean;
    allowSaveCardOnFile?: boolean;
    oneTimeRequest?: boolean;
    showExpressElement?: boolean;
    showAttachment?: boolean;
    skipAttachmentAuth?: boolean;
  };
}

export enum PortalDisabledTypes {
  RateLimit = 'rate-limit-reached',
  Disabled = 'disabled',
}

export type AffirmRedirectParams = {
  payment_intent_client_secret?: string;
  payment_intent?: string;
  paymentId?: string;
  amount?: number;
  receiptEmail?: string;
  firstName?: string;
  lastName?: string;
};
